var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"firebaseui-auth-container"}}),_c('div',{attrs:{"id":"loader"}},[_vm._v("Loading...")]),_c('div',{domProps:{"textContent":_vm._s(_vm.logged)}})])}
var staticRenderFns = []

export { render, staticRenderFns }